import React, { useState } from 'react';
import { ScrollReveal } from './ScrollReveal';
import './Contact.css';

function Contact() {
  const [status, setStatus] = useState('idle'); // 'idle', 'submitting', 'success', 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    const formElement = e.target;
    const formData = new FormData(formElement);
    const data = Object.fromEntries(formData.entries());

    try {
      await fetch(
        'https://script.google.com/macros/s/AKfycbzWpHiOUM6BPow8uKNdxMvLISMFbMMq7yu9IkqmkeAIaZemVLWWEl2LKtnK114BNcAqcQ/exec',
        {
          method: 'POST',
          // Sending as text/plain avoids the strict CORS preflight check, but Apps Script still reads the JSON!
          headers: {
            'Content-Type': 'text/plain;charset=utf-8',
          },
          body: JSON.stringify(data),
        }
      );

      setStatus('success');
      formElement.reset();

      setTimeout(() => {
        setStatus('idle');
      }, 3500);
    } catch (error) {
      console.error('Submission failed', error);
      setStatus('error');
      setTimeout(() => {
        setStatus('idle');
      }, 3500);
    }
  };

  return (
    <section className="sec" id="contact">
      <div className="wrap contact-grid">
        <ScrollReveal direction="right">
          <div className="contact-info">
            <div className="eyebrow">LET'S BUILD</div>
            <h2>Tell us where the friction is.</h2>
            <p>
              Whether it's one broken process or a full operations overhaul, we'll start with a
              conversation about how your business actually runs.
            </p>

            <div className="contact-detail">
              <span className="label">EMAIL</span>
              <span className="value">contact@adap8.com</span>
            </div>
            <div className="contact-detail">
              <span className="label">COMPANY</span>
              <span className="value">adap8 intelligence LLP</span>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal direction="left" delay={0.15}>
          <form aria-label="Contact adap8 intelligence" onSubmit={handleSubmit}>
            <div className="form-row">
              <div>
                <label htmlFor="name">Name</label>
                <input id="name" name="name" type="text" placeholder="Your name" required />
              </div>
              <div>
                <label htmlFor="company">Company</label>
                <input id="company" name="company" type="text" placeholder="Company name" />
              </div>
            </div>
            <div>
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="you@company.com"
                required
              />
            </div>
            <div>
              <label htmlFor="message">What are you looking to solve?</label>
              <textarea
                id="message"
                name="message"
                placeholder="Tell us a bit about your operations and where things feel stuck."
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={status === 'submitting'}>
              {status === 'submitting' && 'Sending...'}
              {status === 'success' && 'Message received ✓'}
              {status === 'error' && 'Error sending (Try again)'}
              {status === 'idle' && 'Send message'}
            </button>
          </form>
        </ScrollReveal>
      </div>
    </section>
  );
}

export default Contact;
